import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_PREVENTIVE_TASK_PROJECTIONS,
  FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS,
  GET_PREVENTIVE_TASK_PROJECTIONS,
} from '../types/task-schedule';
import { PREVENTIVE_TASK_PROJECTION_ENDPOINT } from '../../config/endpoints';

const getPreventiveTaskProjectionDashboard =
  ({ daysToAdd = 0, view = 'USER' } = {}) =>
  async (dispatch) => {
    try {
      dispatch({
        type: FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS,
        payload: true,
      });

      const query = QueryString.stringify({
        daysToAdd,
        view,
      });

      const url = `${PREVENTIVE_TASK_PROJECTION_ENDPOINT}/user?${query}`;

      const response = await fetch(url, DEFAULT_GET_CONFIG);

      await isErrorResponse(response, null, dispatch);

      const payload = await response.json();

      dispatch({
        type: GET_PREVENTIVE_TASK_PROJECTIONS,
        payload,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch({
        type: FLAG_GETTING_PREVENTIVE_TASK_PROJECTIONS,
        payload: false,
      });
    }
  };

const clearPreventiveTaskProjectionDashboard = () => ({
  type: CLEAR_PREVENTIVE_TASK_PROJECTIONS,
});

export {
  getPreventiveTaskProjectionDashboard,
  clearPreventiveTaskProjectionDashboard,
};
